import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/AppContext";
import { ModelPartner } from "@dia-ui/util_interlink-api";
import {generatePath, useLocation, useNavigate} from "react-router";

type SupplierWrapper = { supplier: ModelPartner };

export default function PartnerWall() {
  const {
    getRoutes,
    services: {
      servicePartnerPartner,
      servicePartner
    }
  } = useContext(AppContext);

  /**
   * ROUTE_CONFIG
   */
  const ROUTE_CONFIG = getRoutes(),
    location = useLocation(),
    locationIsLogin = location.pathname.includes(ROUTE_CONFIG.LOGIN.path),
    [partners, setPartners] = useState<SupplierWrapper[]>([]);

  /**
   * navigate
   */
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      let __partners: any[];

      // a failed request used to end as an unhandled rejection and the wall
      // silently rendered as "no partners"
      try {
        if (locationIsLogin) {
          __partners = await servicePartner.getPublicActive();
        } else {
          let _partners = await servicePartnerPartner.getDatatableSuppliers({
            page: 1
          });

          __partners = _partners.data.map((partner: any) => {
            return {
              id: partner.id,
              name: partner.supplier.name,
              hashId: partner.supplier.hashId
            }
          });
        }
      } catch (error) {
        console.error('Error fetching partner data:', error);
        return;
      }

      // for loop we have to use multiple
      // elements to fill the screen on viewport width
      setPartners(locationIsLogin ? [
        ...__partners,
        ...__partners,
        ...__partners,
        ...__partners
      ] : __partners);
    })();
  }, [locationIsLogin, servicePartner, servicePartnerPartner]);

  return (
    /* @ts-ignore */
    <div
      { ...(locationIsLogin && { 'data-dia-slider-partner-login': true }) }
      style={locationIsLogin ? { width: "100vw" } : {}}
    >
      {/* @ts-ignore */}
      { locationIsLogin ? <dia-slider
        { ...(partners.length > 0 && { 'has': "slider" }) }
        data-dia-slider-partner
        data-dia-slider-options={ JSON.stringify(locationIsLogin ? {
          slidesPerView: 'auto',
          autoplay: false
        } : {}) }
        data-dia-loader-placeholder
      >
        {/* @ts-ignore */}
        <dia-slider-track>
          <ul
            data-dia-slider-slides
          >
            { partners.map((partner: any, index: number) => (
              <li key={ partner.hashId + index }>
                <img src={ servicePartner.getCompanyLogoUrl(partner.hashId) } alt={ partner.name } />
              </li>
            )) }
          </ul>
          {/* @ts-ignore */}
        </dia-slider-track>
        {/* @ts-ignore */}
      </dia-slider> : <dia-grid-nested data-dia-slider-partner-grid>
        <dia-grid-row>
          { partners.map((partner: any, index: number) => (
            <dia-grid-column key={ partner.hashId + index }>
              <button onClick={ () => navigate(generatePath(
                ROUTE_CONFIG.PARTNER_VIEW_EDIT.path, {
                  id: partner.id,
                  type: "supplier"
                }
              ))}>
                <img src={ servicePartner.getCompanyLogoUrl(partner.hashId) } alt={ partner.name } />
              </button>
            </dia-grid-column>
          )) }
        </dia-grid-row>
      </dia-grid-nested> }
    </div>
  );
}
